export default __webpack_public_path__ + "static/media/angpao-bg.240b671d.jpg";